import type { IPromo } from "@apis/rewards/types"

// The two offer programs the account offer funnel knows about.
export const OFFER_TYPES = {
  Winback: "Winback",
  Retention: "Retention",
} as const

export type TOfferType = (typeof OFFER_TYPES)[keyof typeof OFFER_TYPES]

export interface IContractType {
  contract_type_code: string
  contract_type_name: string
  unit_type: string
}

export interface IPlan {
  plan_code: string
  plan_description: string
  contract_duration: string
  contract_type_code: string
  plan_name: string
}

export interface IPlanRewardsResponse {
  loyalty_programs: {
    loyalty_program_desc: string
  }[]
  promos: IPromo[]
}

export interface ISaveOfferRequest {
  market_code: string
  revenue_class_code: string
  plan_code: string
  channel_code: string
  market_rate_id: number
}
